function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Creditcard({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.854 4c1.654 0 3 1.346 3 3v11.384c0 1.654-1.346 3-3 3H4c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h15.854zm.999 8.743H2.999L3 18.384c0 .551.449 1 1 1h15.854c.551 0 1-.449 1-1l-.001-5.64zm-13.22 3.63a1 1 0 010 2h-2.7a1 1 0 010-2h2.7zm10.75-1a1.5 1.5 0 11.001 2.998 1.5 1.5 0 01-.001-2.998zm-3.525 0a1.5 1.5 0 11.001 2.998 1.5 1.5 0 01-.001-2.998zm5.995-6.19H2.999v1.56h17.854v-1.56zM19.854 6H4c-.551 0-1 .45-1 1l-.001.182h17.854L20.854 7c0-.55-.449-1-1-1z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoCreditcard = React.memo(Creditcard);
export default MemoCreditcard;